import {
  OrContentBlockA,
  OrContentBlockAProps,
  OrContentBlockB,
  OrContentBlockBProps,
  OrContentBlockC,
  OrContentBlockCProps,
  OrContentBlockD,
  OrContentBlockDProps,
  OrContentBlockE,
  OrContentBlockEProps,
  OrContentBlockF,
  OrContentBlockFProps,
  OrContentBlockG,
  OrContentBlockGProps,
} from '../or-content-block'

export type OrBaseContentProps = {
  layout: `contentBlock${'A' | 'B' | 'C' | 'D' | 'E' | 'F' | 'G'}`
  fields: OrContentBlockAProps &
    OrContentBlockBProps &
    OrContentBlockCProps &
    OrContentBlockDProps &
    OrContentBlockEProps &
    OrContentBlockFProps &
    OrContentBlockGProps
  /** Set when rendered inside a container (e.g. OrContainerTwoCol) that already provides its own side gutter, so this doesn't double it up */
  nested?: boolean
}

/**
 * Container wish responsibility is to render a certain layout
 * @param OrBaseContentProps
 * @returns A component to render (options: OrContentBlockA, OrContentBlockC, OrContentBlockF)
 */
export const OrBaseContent = ({ layout, fields, nested = false }: OrBaseContentProps) => {
  return (
    <div className="lg:mx-auto lg:max-w-screen-lg pt-8 first-of-type:pt-0">
      {layout === 'contentBlockA' && (
        <OrContentBlockA
          title={fields?.title}
          media={fields?.media}
          contents={fields?.contents}
          aspectRatio={fields?.aspectRatio}
          orientation={fields?.orientation}
          variant={fields?.variant}
          onTrackClick={fields?.onTrackClick}
          background={fields?.background}
        />
      )}
      {layout === 'contentBlockB' && (
        <div className="pl-4 sm:pl-8 slg:px-0 lg:pl-[10.438rem]">
          <OrContentBlockB
            title={fields?.title}
            paragraphOne={fields?.paragraphOne}
            content={fields?.content}
            footer={fields?.footer}
            mediaOne={fields?.mediaOne}
            mediaTwo={fields?.mediaTwo}
          />
        </div>
      )}
      {layout === 'contentBlockC' && (
        <OrContentBlockC
          mainText={fields?.mainText}
          title={fields?.title}
          subTitle={fields?.subTitle}
          body={fields?.body}
          signature={fields?.signature}
          media={fields?.media}
          mainTextTwo={fields?.mainTextTwo}
          titleTwo={fields?.titleTwo}
          bodyTwo={fields?.bodyTwo}
          buttonText={fields?.buttonText}
          mediaTwo={fields?.mediaTwo}
          variant={fields?.variant}
          orientation={fields?.orientation}
          button={fields?.button}
          onClick={fields?.onClick}
          onTrackClick={fields?.onTrackClick}
        />
      )}
      {layout === 'contentBlockD' &&
        (nested ? (
          <OrContentBlockD
            title={fields?.title}
            content={fields?.content}
            media={fields?.media}
            ctaBar={fields?.ctaBar}
          />
        ) : (
          <div className="lg:pl-[10.438rem] pl-4 sm:pl-8 slg:pl-12">
            <OrContentBlockD
              title={fields?.title}
              content={fields?.content}
              media={fields?.media}
              ctaBar={fields?.ctaBar}
            />
          </div>
        ))}
      {layout === 'contentBlockE' && (
        <OrContentBlockE
          title={fields?.title}
          subTitle={fields?.subTitle}
          informative={fields?.informative}
          media={fields?.media}
          buttonText={fields?.buttonText}
          button={fields?.button}
          onClick={fields?.onClick}
          onTrackClick={fields?.onTrackClick}
          fullWidth
        />
      )}
      {layout === 'contentBlockF' && (
        <div className="lg:mx-auto lg:max-w-screen-lg py-8">
          <OrContentBlockF
            title={fields?.title}
            body={fields?.body}
            mediaOne={fields?.mediaOne}
            mediaTwo={fields?.mediaTwo}
            orientation={fields?.orientation}
            tabletPadding="2rem"
          />
        </div>
      )}
      {layout === 'contentBlockG' && (
        <div className="py-8 px-4 sm:px-8 slg:px-12 lg:px-[10.438rem]">
          <OrContentBlockG
            title={fields?.title}
            subTitle={fields?.subTitle}
            informative={fields?.informative}
            media={fields?.media}
          />
        </div>
      )}
    </div>
  )
}
